export default "__VITE_ASSET__D5QsP$eN__"